import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { fromEvent, merge, timer, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  readonly oauthService = inject(OAuthService);
  readonly router = inject(Router);
  private destroy$ = new Subject<void>();
  readonly idleTimeout = 180000;

  startWatching() {
    this.destroy$ = new Subject<void>();
    this.setupIdleDetection();
  }

  private setupIdleDetection() {
    const events$ = merge(
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'scroll')
    );

    events$
      .pipe(
        switchMap(() => timer(this.idleTimeout)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.logout());
  }

  private logout() {
    this.oauthService.logOut();
    this.router.navigate(['/']);
  }

  stopWatching() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
